export const container = "SidepanelCss_container";
export const containerTransparent = "SidepanelCss_containerTransparent";
export const containerBlack = "SidepanelCss_containerBlack";
export const mobileBg = "SidepanelCss_mobileBg";
export const closeBtn = "SidepanelCss_closeBtn";
export const logoContainer = "SidepanelCss_logoContainer";
export const logoLine = "SidepanelCss_logoLine";
export const logoIcon = "SidepanelCss_logoIcon";
export const logoText = "SidepanelCss_logoText";
export const tagLine = "SidepanelCss_tagLine";
export const menu = "SidepanelCss_menu";
export const bottomIcon = "SidepanelCss_bottomIcon";
export const row = "SidepanelCss_row";
export const rowIcon = "SidepanelCss_rowIcon";
export const rowActive = "SidepanelCss_rowActive";
